import type { FirstFactorOutcome } from '../../app/modules/types/twoFactor'

/**
 * Read a first-factor response (`jwt/create`, social login, activation).
 *
 * A `200` from these endpoints no longer means "signed in": the two challenge
 * shapes carry NO cookies. Branch on the flag, never on "not an error". A `204`
 * arrives with an empty body, and activation's `200 {role}` carries cookies —
 * both are a session.
 */
export function readFirstFactor(data: unknown): FirstFactorOutcome {
  if (data && typeof data === 'object') {
    const body = data as Record<string, unknown>
    const token = body.challenge_token
    if (typeof token === 'string' && token) {
      const expiresIn = typeof body.expires_in === 'number' ? body.expires_in : 300
      if (body.two_factor_required === true) return { kind: 'verify', challengeToken: token, expiresIn }
      if (body.two_factor_setup_required === true) return { kind: 'setup', challengeToken: token, expiresIn }
    }
  }
  return { kind: 'session' }
}

/** Where a challenge outcome leads; `null` for a session (the caller enters the app). */
export function challengePath(outcome: FirstFactorOutcome): string | null {
  if (outcome.kind === 'verify') return '/auth/two-factor'
  if (outcome.kind === 'setup') return '/auth/two-factor/setup'
  return null
}
